/**
 * Create a new listeners instance
 * @param  {Object} listeners The event listeners to register
 */
function listeners (listeners) {
	return listeners;
}


export default listeners;